<template>
    <div class="kgk-donate">
        <h2 v-if="!insideModal">
            Kilometergeld spenden
        </h2>
        <p>Möchtest du selbst Kilometergeld spenden?</p>
        <p>
            <label>
                <input type="checkbox" v-model="doNotShowAgain" :value="true">&nbsp;Meldung nicht wieder anzeigen
            </label>
        </p>
    </div>
</template>

<script>
export default {
    name: 'DonateForm',
    components: {

    },
    props: {
        insideModal: {
            type: Boolean,
            required: true,
            default: true,
        },
        modalCloseTrigger: {
            type: Object,
            required: false
        },
    },
    data() {
        return {
            doNotShowAgain: false,
        }
    },
    computed: {

    },
    methods: {

    },
    watch: {
        doNotShowAgain(value) {
            this.$emit('change', value);
        },
    },
    mounted() {

    }
}
</script>

